






















import { Component, Vue, Prop } from "vue-property-decorator";
import CContentTop from "@/components/CContentTop.vue";

@Component({
  name: "Crumbs",
  components: {
    CContentTop
  }
})
export default class Crumbs extends Vue {
  @Prop({
    default: () => []
  })
  bread!: Common.CBread[];

  @Prop({
    default: true
  })
  contentTop!: boolean;

  private goto(item: Common.CBread) {
    if (item.url) {
      location.href = item.url;
    } else if (item.to) {
      this.$router.push(item.to);
    }
  }
}
